import Vue from 'vue'
import App from './App.vue'
import router from './routes'
import store from './store'
import VueHighcharts from 'vue-highcharts'
import Vuelidate from 'vuelidate'
import VeeValidate from 'vee-validate'
import VueScreen from 'vue-screen'
import ElementUI from 'element-ui'
import locale from 'element-ui/lib/locale/lang/en'
import 'element-ui/lib/theme-chalk/index.css'

Vue.use(VeeValidate, {
  inject: true,
  fieldsBagName: 'veeFields',
  errorBagName: 'veeErrors',
})

Vue.config.productionTip = false
Vue.use(Vuelidate)
Vue.use(VueHighcharts)
Vue.use(VueScreen, {
  sm: 576,
  md: 768,
  lg: 992,
  xl: 1200,
})
Vue.use(ElementUI, { locale })

new Vue({
  el: '#app',
  router,
  store,
  render: (h) => h(App),
})
